var BitmapDataAsset = (function () {
    function BitmapDataAsset() {
    }
    return BitmapDataAsset;
}());
export { BitmapDataAsset };
